import { render, staticRenderFns } from "./ChatOpened.vue?vue&type=template&id=d06de86a&scoped=true"
import script from "./ChatOpened.vue?vue&type=script&lang=js"
export * from "./ChatOpened.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d06de86a",
  null
  
)

export default component.exports